export const questionsAndAnswers = [
  {
    question: "Kurallarımız Neler?",
    answer: [
      "- Her Cuma öğlen 12.00'da yeni proje platforma eklenir.",
      "- Yeni açılan projelere Cumartesi öğlen 12.00'a kadar sadece Jr. Proje Yöneticisi başvuruları alınır.",
      "- Proje bilgilerini düzenleme yetkisi sadece Jr. Proje Yöneticisi'ndedir.",
      "- Projeye açık pozisyon ekleme yetkisi sadece Jr. Proje Yöneticisi'ndedir.",
      "- Ekip oylamaları her Cuma öğlen 12.00 itibariyle başlar. Cuma 23.59'a kadar süresi vardır.",
      "- Aynı hafta içinde projedeki kişi sayısının %50 veya daha fazlası bir kişi için 'ekipten çıkarılsın' oyu verirse, o kişi ekipten çıkarılması için Juniors operasyon uzmanı tarafından değerlendirilir ve değerlendirme sonucu operasyon uzmanı adayı ekipten çıkarılabilir.",
      "- Ekipten çıkan veya çıkarılan adayın yerine Jr. Proje Yöneticisi tekrar açık pozisyon oluşturup alım yapabilir.",
      "- Açık pozisyon oluşturulduğu andan itibaren 24 saat başvuru almaktadır. 24 saatin sonunda başvuran adaylar arasından sistem otomatik olarak birini projeye dahil edecektir. 24 saatlik sürede açık pozisyona başvuru olmazsa bu süre 24'er saatlik periyotlarla başvuru gelene kadar sistem tarafından uzatılacaktır.",
      "- Projeler, Juniors sunucuları üzerinden yayına alınacaktır.",
      "- Markete atılacak uygulamalar Juniors hesabı üzerinden yayınlanacaktır.",
      "- Projelerde kullanılacak kod versiyonlama sistemleri, iletişim uygulamaları, görev takip uygulamaları vb. proje ekibi tarafından belirlenecektir.",
    ],
    visibleIn: ["sss"],
  },
  {
    question: "Platformu nasıl kullanmaya başlarım?",
    answer:
      "Platforma kaydolduktan sonra, projeler sayfasından size uygun olan projelere başvuru yapabilirsiniz. Başvurular arasından yapılacak çekiliş sonucunda ekibe dahil olup olmadığınız hakkında bildirim alacaksınız.",
    visibleIn: ["home", "sss"],
  },
  {
    question: "Junior'lar ve Senior'lar arasında nasıl bir ilişki vardır?",
    answer: [
      "Junior'lar, belirli bir alanda daha az deneyime sahipken, Senior'lar onlara mentörlük yaparak rehberlik eder. Senior'lar, Junior'ların teknik becerilerini geliştirmelerine yardımcı olur, yönlendirici geribildirim sağlar ve takımın genel verimliliğini artırmak için destek sunar.",
      "Bu platformdaki ekiplerde Junior'ların haftada 15+ saat çalışması beklenirken, Senior'lardan ise haftada en az 1 saat junior arkadaşına mentörlük yapması beklenir.",
    ],
    visibleIn: ["home", "sss"],
  },
  {
    question: "Ekibim içinde performans değerlendirmelerini nasıl yapabilirim?",
    answer:
      "Her hafta, ekip üyeleri birbirlerini anonim olarak puanlayabilir. Bu puanlamalar, bir üyenin güçlü ve zayıf yönlerini anlamasına yardımcı olur ve iyileştirme fırsatları sunar.",
    visibleIn: ["home", "sss"],
  },
  {
    question: "Junior'lar birbirlerini nasıl değerlendirebilir?",
    answer:
      "Junior'lar, takım arkadaşlarını işbirliği, iletişim, görev tamamlama hızları, problem çözme becerisi gibi kriterlere göre değerlendirebilir.",
    visibleIn: ["home", "sss"],
  },
  {
    question: "Senior'lar, Junior'ları nasıl değerlendirebilir?",
    answer:
      "Senior'lar, Junior'ların teknik becerilerini, kod kalitesini, zaman yönetimini, iş birliği yeteneklerini ve görevlerini tamamlama hızlarını değerlendirir.",
    visibleIn: ["sss"],
  },
  {
    question:
      "Ekip içinde birini projeden çıkarmak için nasıl bir süreç izlenir?",
    answer:
      "Ekip üyeleri, bir kişinin performansından memnun değillerse her hafta yapılan puanlamada anonim bir oylama yaparak geribildirim verebilir. Bu oylama sonucunda, ekibin yüzde elli ve daha fazlası ekipten çıkarılsın oyu verdiyse o kişi Juniors operasyon uzmanı tarafından incelenir ve operasyon uzmanının kararı neticesinde projeden çıkarılabilir.",
    visibleIn: ["sss"],
  },
  {
    question: "Geribildirimler anonim mi?",
    answer:
      "Anket değerlendirmelerinde yapacağınız puanlamalar ve takımdan çıkarılsın oylarınız oyladığınız kişi tarafından anonim olarak görülebilecektir. Fakat metinsel bir geribildirim eklerseniz geribildiriminiz kullanıcı adınızla birlikte kullanıcının hesabım sayfasında görüntülenecektir.",
    visibleIn: ["sss"],
  },
  {
    question: "Takım içinde hangi roller yer alabilir?",
    answer:
      "Platformda sadece Jr ve Sr olarak yetkinlikler ayrıştırılmıştır. Junior'lar tasarımcı, yazılımcı, proje yöneticisi gibi roller üstlenebilirken, Senior'lar mentörluk yapar ve teknik rehberlik sağlar. Eğer platformda size uygun bir rol olmadığını düşünüyorsanız bizimle iletişime geçmeniz halinde ekleme yapabiliriz.",
    visibleIn: ["sss"],
  },
  {
    question: "Platformdaki projeler ne tür görevleri içerir?",
    answer:
      "Projeler, genellikle yazılım geliştirme, tasarım, test etme, analiz ve proje yönetimi gibi görevlerden oluşur. Her üye, projenin gereksinimlerine göre kendi görevini yerine getirir.",
    visibleIn: ["sss"],
  },
  {
    question: "Proje Tamamlandıktan Sonra Ne Oluyor?",
    answer:
      "Proje kodları doğrudan Juniors ekibine gönderiliyor. Proje kodlarını alan Juniors ekibi projeyi yayına alıyor. Projedeki ekip aynı şekilde yayındaki projeleri için çalışmaya devam edebiliyor.",
    visibleIn: ["sss"],
  },
  {
    question: "Projeden Kar Elde Edebilir Miyim?",
    answer: [
      "- Kar Payı Dağılımı -",
      "",
      "Proje üzerinde elde edilen net kâr, aşağıdaki kurallara göre dağıtılır:",
      "Platform Payı: Platform, her projeden elde edilen net kârdan %10 pay alır. Platform, bu oranı daha sonra tek taraflı olarak değiştirme yetkisine sahiptir. Oran değişikliği durumunda, bu değişiklik platform üzerinde ilan edilecek ve kullanıcılara e-posta yoluyla bildirilecektir.",
      "Gönüllü Payı: Geriye kalan net kâr, projede çalışan gönüllülerin sayısına ve projede harcadıkları iş günü sayısına bağlı olarak dağıtılır.",
      "",
      "- Kar Hesaplama ve Dağıtım -",
      "",
      "Her ayın 15'inde, bir önceki ay boyunca projeden elde edilen gelir ve projeye ait masraflar (sunucu giderleri vb.) hesaplanarak net kar belirlenir.",
      "Hesaplanan kar, her ayın 15'inde katılımcıların verdikleri IBAN numaralarına gönderilir.",
      "",
      "- İş Günü Hesaplama -",
      "",
      "Projeye katılan kişilerin iş günü hesaplaması, projeye katıldıkları tarih baz alınarak yapılır.",
      "Örneğin, Mart ayı hak edilişleri hesaplanırken;",
      "10 Şubat'tan beri projede olan biri Mart ayında 31 gün çalışmış kabul edilir.",
      "15 Mart'ta projeye katılan biri ise 16 gün çalışmış sayılır.",
      "",
      "- Haziran Ayı Örnek Hakedişi -",
      "",
      "A projesinde 1 Tasarımcı, 1 Tester, 1 Frontend Developer, 1 Backend Developer ve 1 Proje Yöneticisi yer alıyor.",
      "Tester projeye 15 Haziran' da dahil oldu. Diğer ekip üyeleri Haziran ayı boyunca projedeydiler.",
      "Bu durumda Tasarımcı 30 gün, tester 15 gün, Frontend Developer 30 gün, Backend Developer 30 gün, Proje Yöneticisi 30 gün olarak projede çalışılan toplam gün hesaplanır. Haziran ayında toplam 135 gün çalışılmıştır.",
      "Karın %10'u yani 10000TL'si platforma kalmaktadır.",
      "Kalan 90000TL ise çalışılan gün sayısına uygun olarak bölünecektir. Bu durumda 90000TL/135 gün = 666TL'dir.",
      "Tasarımcı 30 gün çalıştığı için 30*666= 19980TL hak etmiştir.",
      "Tester 15 gün çalıştığı için 15*666= 9990TL hak etmiştir.",
      "Frontend Developer 30 gün çalıştığı için 30*666= 19980TL hak etmiştir.",
      "Backend Developer 30 gün çalıştığı için 30*666= 19980TL hak etmiştir.",
      "Proje Yöneticisi 30 gün çalıştığı için 30*666= 19980TL hak etmiştir.",
      "Bu sayede, ekibin her bir üyesi projeden elde edilen kardan adil bir şekilde yararlanır.",
    ],
    visibleIn: ["sss"],
  },
];
